import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { PaginationTranslations } from './pagination.translations.model';
export interface PageRange {
  start: number;
  end: number;
}
export interface JumpList {
  page: number;
}
@Component({
  selector: 'zelis-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginationComponent implements OnInit, OnChanges {
  @HostBinding() class = 'zelis-dls';

  @Input()
  get page(): any {
    return this._page;
  }
  set page(value: any) {
    this._page = parseInt(value.toString(), 10) || 1;
  }
  @Input() length = 0;
  @Input() pageSize = 10;
  @Input() showStats = true;
  @Input() showNextPrev = true;
  @Input() showPageJump = true;
  @Input() translations: PaginationTranslations = new PaginationTranslations();

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() change: EventEmitter<number> = new EventEmitter(true);

  public pages = 0;
  public pageRange: PageRange = { start: 0, end: 0 };
  public jumpList: JumpList[] = [];

  private _page = 1;

  ngOnInit() {
    this.init();
  }

  ngOnChanges() {
    this.init();
  }

  public initPageRange(): PageRange {
    const pageIndex = this.page - 1;
    const startIndex = pageIndex * this.pageSize;
    const endIndex =
      startIndex < this.length
        ? Math.min(startIndex + this.pageSize, this.length)
        : startIndex + this.pageSize;
    return {
      start: this.length ? startIndex + 1 : 0,
      end: this.length ? endIndex : 0,
    };
  }

  public initPages(): number {
    return Math.ceil(this.length / this.pageSize);
  }

  public initJumpList(): JumpList[] {
    const list: any[] = [];
    for (let p = 1; p <= this.pages; p++) {
      list.push({ page: p });
    }
    return list;
  }

  public nextPage(): void {
    this.change.emit(this.page + 1);
  }

  public previousPage(): void {
    this.change.emit(this.page - 1);
  }

  public jumpTo(page: number): void {
    this.change.emit(page);
  }

  private init(): void {
    this.pages = this.initPages();
    this.pageRange = this.initPageRange();
    this.jumpList = this.initJumpList();
  }
}
